<template>
  <div v-if="labels">
    <popup-add-label ref="popupAddLabel" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Labels</h3>
        <p class="mt-5">
          Labels are tags that can be added to a user either manually or with an
          automation or form. It must be added here first.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            v-if="$AuthService.hasPermission('vp.crm.guestprofiles.edit')"
            @click="$refs.popupAddLabel.show()"
            type="relief"
            vslor="primary"
            >Add label</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        max-items="50"
        class="mt-8"
        pagination
        search
        :data="labelsMapped"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="name">Label</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.name }}
                </p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  v-if="$AuthService.hasPermission('vp.crm.guestprofiles.edit')"
                  @click.stop="confirmDelete(tr.name)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PopupAddLabel from "./PopupAddLabel.vue";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  components: { PopupAddLabel },
  data() {
    return {
      moment,
      itemToDelete: "",
    };
  },
  methods: {
    confirmDelete(item) {
      this.itemToDelete = item;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete the item?",
        accept: this.deleteItem,
      });
    },
    async deleteItem() {
      await this.$store.dispatch(
        "guestSegmentation/deleteLabel",
        this.itemToDelete
      );
    },
  },
  computed: {
    ...mapGetters({
      labels: "guestSegmentation/labels",
    }),
    labelsMapped() {
      return this.labels.map((e) => {
        return { name: e };
      });
    },
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("guestSegmentation/get");
    this.$vs.loading.close();
  },
};
</script>
